import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  resources: {},
  lng: 'gr',
  keySeparator: '.',
  interpolation: {
    escapeValue: false
  }
})

const namespaces = [
  'app',
  'authenticate',
  'confirmation',
  'contact-details',
  'contact',
  'continue-later',
  'document-upload',
  'employment-details',
  'error',
  'expired-journey',
  'expired-session',
  'financial-details',
  'form',
  'landing-page',
  'mail-dispatched-modal',
  'personal-details',
  'save-modal',
  'summary',
  'validation',
  'wizard'
]

export default (brandName: string): Promise<void[]> => {
  return Promise.all(
    namespaces.map(async (item) => {
      const baseModule = await import(`../../resources/base/content/${item}.json`)
      i18n.addResourceBundle('gr', item, baseModule.default, true, true)

      try {
        const brandModule = await import(`../../resources/${brandName}/content/${item}.json`)
        i18n.addResourceBundle('gr', item, brandModule.default, true, true)
      } catch {
        // No brand override for this namespace.
      }
    })
  )
}
